export default "<h2 class=\"title\" translate=\"{{ vm.title }}\"></h2>\n<div class=\"body main\">\n  <span translate=\"{{ vm.body }}\"></span>\n</div>\n";